import { Provider, ProviderName } from "@lib/types/Provider";
import NpayexProviderFormItems from "./NpayexProviderFormItems";
import { Form, Input } from "antd";

type Props = {
  provider: Provider;
  objKey: string;
};

export default function ProviderFormItems({ provider, objKey }: Props) {
  const ItemsComponent = () => {
    switch (provider?.name) {
      case ProviderName.Npayex:
        return <NpayexProviderFormItems objKey={objKey} provider={provider} />;

      default:
        return (
          <>
            {Object.entries(provider?.config || {}).map(([key]) => (
              <Form.Item key={key} name={[objKey, key]} label={key}>
                <Input />
              </Form.Item>
            ))}
          </>
        );
    }
  };

  return (
    <>
      <ItemsComponent />
    </>
  );
}
